<script setup lang="ts">
import Dropdown from "primevue/dropdown";
import Textarea from "primevue/textarea";
import type { Ref } from "vue";
import { MAX_NOTE_TEXTAREA_LIMIT } from "@/constants";
import type { Reason } from "../types";

interface Props {
  dropdown: string | undefined;
  textarea: string | undefined;
  options: Reason[];
  error: boolean;
  errorMessage?: string | Ref<string>;
  inputId?: string;
  disabled?: boolean;
  otherVisible: boolean;
  textareaError: boolean;
  textareaErrorMessage?: string | Ref<string>;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: "update:dropdown", value: string | null): void;
  (e: "update:textarea", value: string | null): void;
}>();
</script>

<template>
  <div>
    <div class="flex flex-col gap-5">
      <!-- Reason Select -->
      <div class="flex-1">
        <label :for="inputId" class="whitespace-nowrap text-sm font-semibold block mr-2">
          Reason for Cancellation
        </label>
        <Dropdown
          :model-value="dropdown"
          @update:model-value="emit('update:dropdown', $event)"
          :options="options"
          optionLabel="label"
          optionValue="id"
          class="w-full mt-1"
          :disabled="disabled"
          :invalid="error"
        />
        <p class="common-error-text" v-if="error">
          {{ errorMessage }}
        </p>
      </div>

      <!-- Reason text -->
      <div class="flex flex-col" v-if="otherVisible">
        <span class="common-label-text">Cancellation Reason</span>
        <Textarea
          :model-value="textarea"
          :disabled="disabled"
          :invalid="textareaError"
          :maxlength="MAX_NOTE_TEXTAREA_LIMIT"
          @update:model-value="emit('update:textarea', $event)"
        />
        <p class="common-error-text" v-if="textareaError">
          {{ textareaErrorMessage }}
        </p>
      </div>
    </div>
  </div>
</template>
